import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'meu-modal-sign-up-success',
  templateUrl: './modal-sign-up-success.component.html',
  styleUrls: ['./modal-sign-up-success.component.scss']
})
export class ModalSignUpSuccessComponent implements OnInit {
  emailName: string = "";
  isEmail: boolean = true;

  constructor(
	private dialogRef: MatDialogRef<ModalSignUpSuccessComponent>,
	@Inject(MAT_DIALOG_DATA) public data,
  ) { }

  ngOnInit() {
	  this.emailName = this.data.email || this.data.phone || '';
	  // Kiểm tra nếu là email hay số điện thoại
	  this.isEmail = this.data.email ? true : false;
  }
  closeModal(){
	this.dialogRef.close(true);
  }
}
